import { useEffect, useMemo, useState } from 'react';

export const LIST_CAP = 1000;
export const CAP_PAGE_SIZE = 100;

/** Global cap rule: lists over 1,000 render only the top 1,000, paginated 100 per page. */
export function useCappedPages<T>(items: T[], pageSize = CAP_PAGE_SIZE, cap = LIST_CAP) {
  const [page, setPage] = useState(0);
  const capped = useMemo(() => items.slice(0, cap), [items, cap]);
  const pages = Math.max(1, Math.ceil(capped.length / pageSize));
  const current = Math.min(page, pages - 1);

  useEffect(() => setPage(0), [items.length]);

  return {
    visible: capped.slice(current * pageSize, current * pageSize + pageSize),
    page: current,
    pages,
    setPage,
    total: items.length,
    isCapped: items.length > cap,
    offset: current * pageSize,
  };
}
